const AI_INSIGHTS_URL =
  process.env.REACT_APP_DASHBOARD_AI_URL || "/api/dashboard/ai-insights";

const postAiInsights = async (token, body) => {
  const response = await fetch(AI_INSIGHTS_URL, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload.error || "Could not load suggestions.");
    error.status = response.status;
    throw error;
  }

  if (payload?.error) {
    throw new Error(payload.error);
  }

  return payload;
};

export const fetchAiInsights = async (token, dashboard, mode = "analytics") => {
  const payload = await postAiInsights(token, { dashboard, mode });

  if (mode === "operations") {
    if (!payload?.headline || !Array.isArray(payload?.suggestions)) {
      throw new Error(
        "Suggestions came back in an unexpected format. Try again in a moment."
      );
    }
  } else if (!payload?.headline || (!Array.isArray(payload?.topics) && !Array.isArray(payload?.suggestions))) {
    throw new Error(
      "Explanation came back in an unexpected format. Try again in a moment."
    );
  }

  return payload;
};

const viewToMode = (activeView) =>
  activeView === "enrollment" ? "operations" : "analytics";

export const askAiQuestion = async (
  token,
  question,
  activeView = "overview",
  conversationHistory = []
) => {
  const trimmed = String(question || "").trim();
  if (!trimmed) {
    throw new Error("Please enter a question.");
  }

  const payload = await postAiInsights(token, {
    mode: viewToMode(activeView),
    activeView,
    question: trimmed,
    conversationHistory: Array.isArray(conversationHistory) ? conversationHistory : [],
  });

  if (payload?.type === "question" && payload?.answer) {
    return payload;
  }

  if (payload?.headline && payload?.type !== "question") {
    throw new Error(
      "The advisor did not receive your question correctly. Restart the dashboard server (npm run start:dashboard) and try again."
    );
  }

  throw new Error(
    payload?.error || "The answer came back in an unexpected format. Try again."
  );
};
